import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ItemPropertyModel } from './models/item-property-model';

@Injectable({
  providedIn: 'root',
})
export class ItemPropertiesService {
  public _http: HttpClient;
  public baseUrlLocal: string = "";

  constructor(private http: HttpClient) {
      this._http = http;
      this.baseUrlLocal = environment.apiBaseUrl;
  }

  public getItemProperties(itemId: string): Observable<ItemPropertyModel[]> {
    return this.http.get<ItemPropertyModel[]>(`${this.baseUrlLocal}itemproperties/${itemId}`);
  }

  public getItemProperty(itemId: string, key: string): Observable<ItemPropertyModel> {
    return this.http.get<ItemPropertyModel>(`${this.baseUrlLocal}itemproperties/${itemId}/${key}`);
  }

  public createItemProperty(itemProperty: ItemPropertyModel): Observable<ItemPropertyModel> {
    return this.http.post<ItemPropertyModel>(`${this.baseUrlLocal}itemproperties`, itemProperty);
  }

  public updateItemProperty(itemProperty: ItemPropertyModel): Observable<ItemPropertyModel> {
    return this.http.put<ItemPropertyModel>(`${this.baseUrlLocal}itemproperties`, itemProperty);
  }

  public deleteItemProperty(itemId: string, key: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrlLocal}itemproperties/${itemId}/${key}`);
  }
}
